import type { ReactElement, SVGProps } from "react";

export function UnavailableIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  const { fill = "#7E82AD", ...restProps } = props;

  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M8.125 0C3.64167 0 0 3.64167 0 8.125C0 12.6083 3.64167 16.25 8.125 16.25C12.6083 16.25 16.25 12.6083 16.25 8.125C16.25 3.64167 12.6083 0 8.125 0ZM11.4583 8.66667H4.79167C4.49167 8.66667 4.25 8.425 4.25 8.125C4.25 7.825 4.49167 7.58333 4.79167 7.58333H11.4583C11.7583 7.58333 12 7.825 12 8.125C12 8.425 11.7583 8.66667 11.4583 8.66667Z"
        fill={fill}
      />
    </svg>
  );
}
